module.exports = __webpack_public_path__ + "static/media/booking-pending.466b7ad1.svg";